import React from 'react'
import StackedTagSelect from '../../../../../components/stacked-tag-select/stacked-tag-select'
import { useService } from '@pushly/aqe/lib/hooks/use-service'
import { AppService } from '../../../../../services'
import { PromptGroupPageConditions } from '@pushly/models/lib/structs/prompts/prompt-group-page-conditions'
import { Form, Space, Typography } from 'antd'

type Props = {
    value?: PromptGroupPageConditions
    onChange: (value: PromptGroupPageConditions) => void
}

export const MetaKeywordsConditionEditor: React.FC<Props> = ({ value, onChange }) => {
    const appSvc = useService(AppService)

    const conditions = value ?? new PromptGroupPageConditions()

    return (
        <Space vertical>
            <Typography.Paragraph>
                Enabling this condition will restrict the prompt to a specific group of pages determined by each page's
                meta keywords.
            </Typography.Paragraph>

            <Form.Item layout="vertical" label="Show prompt on pages with the following meta-tag keywords">
                <StackedTagSelect<string[]>
                    size="small"
                    mode="tags"
                    placeholder="Keywords"
                    maxTagCount={5}
                    getPopupContainer={appSvc.getAppContainer}
                    tokenSeparators={[',']}
                    showOptions={false}
                    defaultValue={conditions.keywords ?? []}
                    onChange={(keywords) => {
                        const update = conditions.clone()
                        update.keywords = keywords
                        onChange(update)
                    }}
                    notFoundContent=""
                />
            </Form.Item>
        </Space>
    )
}
